import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import { Box } from "@mui/material";
import {
    Accordion,
    AccordionPanel,
    AccordionItem,
    AccordionButton,
    AccordionIcon,
} from "@chakra-ui/react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
} from "@material-ui/core";
import { updatePassword } from "../store/action/auth";

// Boîte « Modifiez votre mot de passe » (changement obligatoire : premier accès ou mot de passe expiré).
// Extraite du tableau de bord pour pouvoir l'afficher sur la page /changer-mot-de-passe, accessible à tout
// compte connecté : les experts n'ont pas VIEW_DASHBOARD et ne doivent pas passer par /dashboard.
const useStyles = makeStyles(() => ({
    dialogPaper: { overflow: "hidden" },
    dialogTitle: {
        fontFamily: "Poppins",
        fontWeight: 500,
        fontSize: 15,
        color: "rgba(63, 66, 84, 1)",
        backgroundColor: "white",
        borderBottom: "1px solid #E5EAEE",
    },
    cardText: {
        fontFamily: "Poppins",
        fontSize: "13px",
        fontWeight: 400,
        color: "rgba(70, 78, 95, 1)",
    },
    styleInput: {
        fontFamily: "Poppins",
        fontSize: "13px",
        fontWeight: 500,
        border: 0,
        background: "rgba(243, 246, 249, 1)",
        color: "rgba(24, 28, 50, 0.58)",
        lineHeight: "21px",
        padding: "5px",
        height: "36px",
        borderRadius: "4px",
    },
}));

const PASSWORD_RULE = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>+_-]).{12,20}$/;

function PasswordChangeDialog({ open, onSuccess }) {
    const classes = useStyles();
    const username = localStorage.getItem("username");
    const [mdp, setMdp] = useState("");
    const [newMdp, setNewMdp] = useState("");

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = "/maeassurance/login";
    };

    const handleSubmit = async () => {
        if (!PASSWORD_RULE.test(mdp)) {
            toast.error(
                "Veuillez entrer un mot de passe valide (au moins une majuscule, une minuscule, un chiffre, un caractère spécial, et longueur entre 12 et 20 caractères)."
            );
            return;
        }
        if (mdp !== newMdp) {
            toast.error("Les mots de passe ne correspondent pas.");
            return;
        }
        try {
            const data = await updatePassword(mdp);
            localStorage.setItem("updatedPassword", "true");
            if (data?.updatedUser?.passwordExpirationDate) {
                localStorage.setItem("passwordExpirationDate", new Date(data.updatedUser.passwordExpirationDate));
            }
            toast.success("Votre mot de passe a été modifié avec succès.");
            if (onSuccess) onSuccess();
        } catch (error) {
            toast.error("Une erreur est survenue lors de la mise à jour du mot de passe.");
            console.error("[PasswordChangeDialog]", error);
        }
    };

    const field = (label, value, onChange, disabled = false) => (
        <div style={{ display: "flex", flexDirection: "column", marginBottom: "1rem" }}>
            <label className={classes.cardText} style={{ marginBottom: "0.5rem" }}>{label}</label>
            <input
                className={classes.styleInput}
                value={value}
                onChange={onChange}
                disabled={disabled}
                type={disabled ? "text" : "password"}
            />
        </div>
    );

    return (
        <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
            <DialogTitle className={classes.dialogTitle} style={{ backgroundColor: "rgba(243, 246, 249, 1)" }}>
                Modifiez votre mot de passe
            </DialogTitle>
            <DialogContent>
                <Accordion allowMultiple defaultIndex={[0]}>
                    <AccordionItem>
                        <AccordionButton style={{ height: "47px", border: "none", background: "rgba(255, 255, 255, 1)", borderBottom: "none" }}>
                            <AccordionIcon
                                size="30px"
                                style={{ backgroundColor: "rgba(240, 243, 199, 1)", width: "25px", height: "25px", borderRadius: "5px", color: "rgba(187, 200, 8, 1)" }}
                            />
                            <Box
                                as="div"
                                textAlign="left"
                                marginLeft="20px"
                                style={{ color: "rgba(0, 34, 38, 1)", fontSize: "14px", fontWeight: 500, lineHeight: "21px", fontFamily: "Poppins" }}
                            >
                                Informations générales
                            </Box>
                        </AccordionButton>
                        <AccordionPanel>
                            <div style={{ marginLeft: "1rem" }}>
                                {field("Nom d'utilisateur", username, undefined, true)}
                                {field("Saisissez votre nouveau mot de passe", mdp, (e) => setMdp(e.target.value))}
                                {field("Répétez votre nouveau mot de passe", newMdp, (e) => setNewMdp(e.target.value))}
                                <div style={{ display: "flex", flexDirection: "column", marginBottom: "1rem", textAlign: "justify" }}>
                                    Pour garantir la sécurité de votre compte, votre mot de passe doit contenir entre 12 et 20 caractères, incluant au moins une lettre majuscule, une lettre minuscule, un chiffre (0–9) et un caractère spécial (comme @, #, $, %, !, etc.).
                                </div>
                            </div>
                        </AccordionPanel>
                    </AccordionItem>
                </Accordion>
            </DialogContent>
            <DialogActions>
                <Button
                    style={{ fontFamily: "Poppins", fontSize: "10.76px", fontWeight: 600, lineHeight: "16.14px", color: "rgba(255, 54, 54, 1)", background: "rgba(255, 229, 229, 1)", width: "fit-content", height: "26px", borderRadius: "5.38px", marginRight: "10px" }}
                    onClick={handleLogout}
                    color="secondary"
                >
                    Deconnexion
                </Button>
                <Button
                    style={{ fontFamily: "Poppins", fontSize: "10.76px", fontWeight: 600, lineHeight: "16.14px", color: "rgba(255, 255, 255, 1)", background: "rgba(60, 101, 86, 1)", width: "61.08px", height: "26.71px", borderRadius: "5.38px", marginRight: "10px" }}
                    onClick={handleSubmit}
                    color="primary"
                >
                    Modifier
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default PasswordChangeDialog;
